import * as React from 'react';
import Flickity, {FlickityOptions} from 'react-flickity-component';
import {GalleryValue} from 'api/lesson/types';
import Column from './Column';

export interface GalleryTemplateProps {
  value?: GalleryValue;
}

/**
 * This is the gallery block of the lesson viewer.
 * @param {GalleryTemplateProps} props
 * @return {React.ReactElement<GalleryTemplateProps> | null}
 * @constructor
 */
export default function GalleryTemplate(
    props: GalleryTemplateProps,
): React.ReactElement<GalleryTemplateProps> | null {
  const options: FlickityOptions = {
    pageDots: false,
    cellAlign: 'center',
    // draggable: false,
  };

  return props.value ? (
    <Flickity options={options}>
      {props.value.map((column, index) => (
        <Column key={index} value={column} />
      ))}
    </Flickity>
  ) : null;
}
